import Vue from "vue";
import Router from "vue-router";
import GoogleAuthService from "./services/GoogleAuthService"

Vue.use(Router);

function guardMyRoute(to, from, next){ 
        let token = Vue.cookie.get("session-token");
        GoogleAuthService.verify(JSON.stringify({ token: token})).then(
          (response) => {
            if (response.data == null) {
              next("/")
            } else {
              next();
            }

          }
        ).catch(err =>{

          console.log("ERR",err)
        })

}

export default new Router ({
    mode: "history",
    routes: [
        {
            path: "/vps",
            name: "VPS List",
            beforeEnter: guardMyRoute,
            component: () => import("./components/VMList")
        },
        {
            path: "/home",
            name: "Home",
            beforeEnter: guardMyRoute,
            component: () => import ("./components/Home")
        },
        {
            path: "/",
            name: "Login",
            component: () => import ("./components/LoginNew")
        },

        {
            path: "/metadata/:selector",
            name: "Metadata", 
            beforeEnter: guardMyRoute,
            component: () => import("./components/MetaDataTable")
        },
        {
          path: "/campaigns/:id",
          name: "Campaign", 
          beforeEnter: guardMyRoute,
          component: () => import("./components/DetailViewCampaign")
        },
        {
          path: "/profile_owners/:id",
          name: "Profile Owner", 
          beforeEnter: guardMyRoute,
          component: () => import("./components/DetailViewProfileOwner")
        },
        {
          path: "/vps/:id",
          name: "VPS", 
          beforeEnter: guardMyRoute,
          component: () => import("./components/DetailViewVPS")
        },
        {
          path: "/admin",
          name: "Admin", 
          beforeEnter: guardMyRoute,
          component: () => import("./components/UAMDashboard")
        },
        
       
    ]
});